/**
 * Cover Note Routes
 */

import { lazy } from 'react';
import { LAYOUT_TYPES, ROUTE_PATHS } from 'navigation/constants';
import type { RouteGroup } from 'navigation/types';

const CoverNotesPage = lazy(() => import('@/features/cover-notes/ui/pages/cover-notes-page'));
const CoverNoteCreatePage = lazy(() => import('@/features/cover-notes/ui/pages/add-cover-note-page'));
const CoverNoteDetailPage = lazy(() => import('@/features/cover-notes/ui/pages/cover-note-detail-page'));

export const coverNoteRoutes: RouteGroup = {
  name: 'cover-notes',
  layout: LAYOUT_TYPES.DASHBOARD,
  permission: {
    requiresAuth: true,
  },
  routes: [
    {
      path: ROUTE_PATHS.COVER_NOTES,
      component: CoverNotesPage,
      meta: {
        title: 'Cover Notes',
        showInNav: true,
        navOrder: 2,
      },
    },
    {
      path: ROUTE_PATHS.COVER_NOTE_CREATE,
      component: CoverNoteCreatePage,
      meta: {
        title: 'Issue Cover Note',
        parent: ROUTE_PATHS.COVER_NOTES,
      },
    },
    {
      // Same wizard, reopened on a Draft/Rejected cover note for correction
      path: ROUTE_PATHS.COVER_NOTE_EDIT,
      component: CoverNoteCreatePage,
      meta: {
        title: 'Edit Cover Note',
        parent: ROUTE_PATHS.COVER_NOTES,
      },
    },
    {
      path: ROUTE_PATHS.COVER_NOTE_DETAIL,
      component: CoverNoteDetailPage,
      meta: {
        title: 'Cover Note Detail',
        parent: ROUTE_PATHS.COVER_NOTES,
      },
    },
  ],
};
